import * as actions from "@/modules/auth";

const login = async ({ commit }, credentials) => {
  const { email, password, code, recaptcha } = credentials;

  try {
    const response = await actions.login(email, password, code, recaptcha);

    const { token, refreshToken, user } = response.data;

    commit("setSessionUser", { token, refreshToken, user });
  } catch (error) {
    commit("clearSession");
    throw error;
  }
};

const logout = async ({ commit }) => {
  try {
    await actions.logout();
  } catch (error) {
    throw error;
  } finally {
    commit("clearSession");
  }
};

let refreshPromise = null;

const refreshToken = async ({ commit, state }) => {
  if (refreshPromise !== null) {
    return refreshPromise;
  }

  const { refreshToken } = state;

  refreshPromise = actions.refreshToken(refreshToken);

  try {
    const response = await refreshPromise;
    const { token, refreshToken, user } = response.data;

    commit("setSessionUser", { token, refreshToken, user });

    return response;
  } catch (error) {
    commit("clearSession");
    throw error;
  } finally {
    refreshPromise = null;
  }
};

const getSession = async ({ commit }, token) => {
  try {
    const response = await actions.getSession(token);

    const { user } = response.data;
    commit("setSessionUser", { token, user });
  } catch (error) {
    commit("clearSession");
    throw error;
  }
};

const sendPasswordReset = async (_, request) => {
  try {
    return await actions.sendPasswordReset(request);
  } catch (error) {
    throw error;
  }
};

const resetPassword = async (_, request) => {
  try {
    return await actions.resetPassword(request);
  } catch (error) {
    throw error;
  }
};

const setToken = async ({ commit }, token) => {
  commit("setToken", { token });
};

export default {
  login,
  logout,
  refreshToken,
  getSession,
  sendPasswordReset,
  resetPassword,
  setToken
};
